import React, { forwardRef } from 'react';

import { Card } from 'uikit/cards';

import DefaultImage from '../images/defaultImage.svg';

import styles from '../styles/cardImage.module.scss';

const CardImage = forwardRef(({
  image,
  imageAlt,
  to,
  onClick,
  isExternalLink,
}, ref) => (
  <Card
    className={styles.element}
    ref={ref}
    to={to}
    isExternalLink={isExternalLink}
    onClick={onClick}
  >
    <div className={styles.content}>
      <div className={styles.image}>
        {image ? (
          <img
            className={styles.imageSrc}
            src={image}
            alt={imageAlt || ''}
          />
        ) : (
          <DefaultImage className={styles.imageSrc} />
        )}
      </div>
    </div>
  </Card>
));

CardImage.displayName = 'CardImage';

export default React.memo(CardImage);
